import {Form} from 'react-bootstrap'
import {TextInputV2} from '../../../components/TextInputV2'
import {FC, useCallback, useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {
  filterSelector,
  resetFilterCustomer,
  setFilterCustomer,
} from '../../../redux/slices/filterSlices'
import {fetchCustomers, headers} from '../../../services/fetcher'
import {TableLoader} from '../../../components/TableLoader'
import {TableFailedFetchData} from '../../../components/TableFailedFetchData'
import {TableEmptyData} from '../../../components/TableEmptyData'
import axios from 'axios'
import {objToParams} from '../../../utils/objToParams'
import Pagination from '../component/Pagination'
import Skeleton from 'react-loading-skeleton'

interface TableBrowseCustomerProps {
  onSelectedCustomer: (item: any) => void
}

export const TableBrowseCustomer: FC<TableBrowseCustomerProps> = (props) => {
  const {t} = useTranslation()
  const {filterCustomer: filter} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()

  const [customers, setCustomers] = useState([])
  const [numberUrl, setNumberUrl] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [isError, setIsError] = useState(false)

  const handleReloadTable = () => {
    dispatch(resetFilterCustomer())
    onFetchCustomers()
  }

  const handleFilterChange = (value: Partial<typeof filter>) => {
    dispatch(setFilterCustomer({...filter, ...value}))
  }

  const onFetchCustomers = useCallback(() => {
    setIsLoading(true)
    fetchCustomers(filter)
      .then((res) => {
        const {data, links} = res.data.data
        setCustomers(data)
        setNumberUrl(links)
      })
      .catch(() => setIsError(true))
      .finally(() => setIsLoading(false))
  }, [filter])

  const paginateNumber = async (url: string) => {
    if (!url) return

    try {
      setIsLoading(true)

      const token = localStorage.getItem('token') as string
      const endpoint = `${url}&${objToParams(filter)}`
      const res = await axios.get(endpoint, {
        headers: {...headers, Authorization: `Bearer ${token}`},
      })

      setCustomers(res.data.data.data)
      setNumberUrl(res.data.data.links)
    } catch (error) {
      setIsError(true)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    const fetcher = setTimeout(onFetchCustomers, 1000)
    return () => clearTimeout(fetcher)
  }, [onFetchCustomers])

  useEffect(() => {
    handleReloadTable()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className='table-responsive bdr'>
      <table className='table'>
        <thead>
          <tr className='d-flex jusify-content-center w-100 align-items-center'>
            <th className='td-order-11 text-center'></th>
            <th className='td-order-4 text-center'>{t('Customer Code')}</th>
            <th className='td-order-4 text-center'>{t('Customer Name')}</th>
          </tr>
        </thead>
        <tbody>
          <tr className='d-flex jusify-content-center w-100 align-items-center'>
            <td className='td-order-11 text-center'>
              <div className='text-transparent' style={{padding: '.42rem 0'}}>
                -
              </div>
            </td>
            <td className='td-order-4 text-center pm-0'>
              <TextInputV2
                placeholder={t('Customer Code')}
                style={{padding: '8px 0', border: 0}}
                value={filter?.customer_code ?? ''}
                onChange={({target}) => handleFilterChange({customer_code: target.value})}
              />
            </td>
            <td className='td-order-4 text-center pm-0'>
              <TextInputV2
                placeholder={t('Customer Name')}
                style={{padding: '8px 0', border: 0}}
                value={filter?.name ?? ''}
                onChange={({target}) => handleFilterChange({name: target.value})}
              />
            </td>
          </tr>
          {isLoading ? [1,2,3,4].map((item) => {
              return <tr key={item} className='d-flex jusify-content-center w-100 align-items-center'>
                <td className='td-order-11 text-center'>
                  <Skeleton width={'80%'} height={30}/>
                </td>
                <td className='td-order-4 text-center'>
                <Skeleton width={'80%'} height={30}/></td>
                <td className='td-order-4 text-center'>
                <Skeleton width={'80%'} height={30}/></td>
              </tr>
            })
          : isError ? (
            <TableFailedFetchData onReloadTable={handleReloadTable} />
          ) : customers.length === 0 ? (
            <TableEmptyData onReloadTable={handleReloadTable} />
          ) : (
            customers?.map((item: any, index: number) => {
              return (
                <tr
                  key={item?.id ?? index}
                  className={`d-flex jusify-content-center w-100 align-items-center ${
                    index % 2 === 0 && 'bg-secondary'
                  }`}
                >
                  <td className='td-order-11 text-center checkk'>
                    <Form.Check
                      reverse
                      type='checkbox'
                      id={item?.customer_code}
                      onChange={(e: any) => props.onSelectedCustomer(item)}
                    />
                  </td>
                  <td className='td-order-4 text-center'>
                    <span className='d-block'>
                      {item.customer_code}
                    </span>
                  </td>
                  <td className='td-order-4 text-center'>
                    <span className='d-block'>
                      {item.name}
                    </span>
                  </td>
                </tr>
              )
            })
          )}
        </tbody>
      </table>

      <div className='my-5'>
        <Pagination paginate={paginateNumber} test={numberUrl} />
      </div>
    </div>
  )
}
